import React, { useEffect, useState } from "react";
import { PanelContainer } from "../Components/PanelContainer";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import { fetchData } from "../Components/Utilities";
import Cookies from "js-cookie";
import { FileUpload } from "primereact/fileupload";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { SelectButton } from "primereact/selectbutton";

export const ImportUserFromExcel = () => {
  const [groupList, setGroupList] = useState([]);
  const [groupItem, setGroupItem] = useState("");
  const orgOptions = ["غیرسازمانی", "سازمانی"];
  const [org, setOrg] = useState(orgOptions[0]);
  const [excelFile, setExcelFile] = useState("");
  useEffect(() => {
    fetchData("grouplist", {}, handleGroupListResponse);
  }, []);
  const handleGroupListResponse = (data) => {
    const mapCats = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.id.toString(),
        label: item.groupname,
      }));
    };
    const formattedOptions = mapCats(data?.dt);
    setGroupList(formattedOptions);
  };
  const sendUsers = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("org", org === "سازمانی" ? "1" : "0");
    bodyFormData.append("groupid", groupItem);
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("excel", excelFile);
    fetchData("createuserexcel", bodyFormData, handleSendUsersResponse);
  };
  const handleSendUsersResponse = (data) => {
  if(data?.code ===1){

    SweetAlert({
      title: "",
      text: `تعداد ${data?.code} نفر کاربر جدید با موفقیت اضافه شد.`,
      type: "success",
    });
  }else{
    SweetAlert({
      title: "",
      text: `${data?.msg}`,
      type: "error",
    });

  }
  };
  const handleUpload = (event) => {
    console.log(event.target.files);
    setExcelFile(event.target.files[0]);
  };
  return (
    <PanelContainer title={" افزودن کاربران توسط اکسل"} className={"w-50"}>
      <div className="md-p-5">
        <Button className="btn-dark mb-3">
          <Link
            to={`https://api.taab30.com/contactraw.xlsx`}
            className=" text-white text-decoration-none"
          >
            دانلود فایل اکسل خام
          </Link>
        </Button>
        <Row>
          <Col className="col-12 col-lg-6 pb-3">
            <FileUpload
              mode="basic"
              accept=".xls, .xlsx"
              maxFileSize={1000000}
              chooseLabel="آپلود فایل اکسل  "
              className="pb-3 btn btn-sm"
              onSelect={(e) => {
                console.log(e.files[0]);
                setExcelFile(e.files[0]);
              }}
            />
          </Col>
          <Col className="col-12 col-lg-6">
            <SelectButton
              dir="ltr"
              className="btn btn-sm"
              value={org}
              onChange={(e) => {
                console.log(e.value);
                setOrg(e.value);
              }}
              options={orgOptions}
            />
          </Col>
        </Row>
        <Row>
          <Col className="col-12 col-lg-6">
            <select
              defaultValue={""}
              className="form-select"
              value={groupItem}
              onChange={(e) => setGroupItem(e.target.value)}
            >
              <option value="" disabled={true}>
                انتخاب کنید...
              </option>
              {groupList?.map((group, i) => (
                <option key={i} value={group.value}>
                  {group.label}
                </option>
              ))}
            </select>
          </Col>
          <Col className="col-12 col-lg-6 m-3">
            <Button onClick={sendUsers} type="button">
              ذخیره
            </Button>
          </Col>
        </Row>
      </div>
    </PanelContainer>
  );
};
